import ApiService from "./ApiService";

const distributionLogService = {
  getDistributionLogs(date, providerId) {
    date = date || "";
    return ApiService.get(
      `/distribution-log?date=${date}&providerId=${providerId}`
    );
  }
};

export default distributionLogService;
